module.exports = __webpack_public_path__ + "static/img/20-0827-detail.61a24d6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/20-0827-detail.jpeg
// module id = Z/vd
// module chunks = 0